import { ListResponse } from '@/types/common';
import { CardCategoryInfo, MemberCardInfo, MemberCardSaleStatus } from '@/types/member-card';
import { cleanObject } from '@/utils';
import { requestWrapper } from '@/utils/request';

// 创建会员卡种
export async function createCardCategory(body: Partial<CardCategoryInfo>) {
  return requestWrapper<CardCategoryInfo>('/api/member_card_type/create', {
    method: 'POST',
    data: body,
  });
}

// 更新会员卡种
export async function updateCardCategory(body: Partial<CardCategoryInfo>) {
  return requestWrapper<CardCategoryInfo>('/api/member_card_type/update', {
    method: 'POST',
    data: body,
  });
}

// 获取会员卡种列表
export async function getCardCategories() {
  return requestWrapper<CardCategoryInfo[]>('/api/member_card_type/list', {
    method: 'GET',
  });
}

// 获取会员卡列表
export async function getMemberCardList() {
  return requestWrapper<MemberCardInfo[]>('/api/member_card/list', {
    method: 'GET',
  });
}

// 获取会员卡列表分页
export async function getMemberCardListPage(params: {
  page: number;
  page_size: number;
  admin_status?: MemberCardSaleStatus;
  member_card_type_ids?: number[]; // 卡种筛选
  use_store_ids?: number[]; // 适用门店筛选
}) {
  return requestWrapper<ListResponse<MemberCardInfo>>('/api/member_card/list_page', {
    method: 'GET',
    params: cleanObject(params),
  });
}

// 创建会员卡
export async function createMemberCard(body: Partial<MemberCardInfo>) {
  return requestWrapper<MemberCardInfo>('/api/member_card/create', {
    method: 'POST',
    data: cleanObject(body),
  });
}

// 更新会员卡信息
export async function updateMemberCard(body: Partial<MemberCardInfo>) {
  return requestWrapper<MemberCardInfo>('/api/member_card/update', {
    method: 'POST',
    data: cleanObject(body),
  });
}
